import { InputDate } from './InputData'
import { InputIcon } from './InputIcon'
import { InputPassword } from './InputPassword'
import { InputPrefix } from './InputPrefix'
import { InputRoot } from './InputRoot'

export const InputComp = {
  root: InputRoot,
  password: InputPassword,
  icon: InputIcon,
  prefix: InputPrefix,
  date: InputDate,
}
